export default __webpack_public_path__ + "static/media/UserDefaultAvatar.46567d09.svg";